import { render, staticRenderFns } from "./HeadlineMonthCard.vue?vue&type=template&id=c21b51de&scoped=true"
import script from "./HeadlineMonthCard.vue?vue&type=script&lang=js"
export * from "./HeadlineMonthCard.vue?vue&type=script&lang=js"
import style0 from "./HeadlineMonthCard.vue?vue&type=style&index=0&id=c21b51de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21b51de",
  null
  
)

export default component.exports